type Listener = () => void;

let authed = false;
let initialized = false;
const listeners = new Set<Listener>();

export function getIsAuthed(): boolean {
  return authed;
}

export function getIsInitialized(): boolean {
  return initialized;
}

export function setInitialized(value: boolean): void {
  initialized = value;
  for (const l of listeners) l();
}

export function setAuthed(value: boolean): void {
  authed = value;
  for (const l of listeners) l();
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
